import clsx from 'clsx';
import Kbd from '../KeyboardShortcutsModal/Kbd';

interface MenuItemProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  /**
   * Single-key accelerator badge shown at the trailing edge. Purely a hint —
   * the key itself is bound by whichever menu owns the item (see
   * BookmarkActionsMenu).
   */
  shortcut?: string;
}

function MenuItem({
  onClick,
  disabled,
  children,
  className,
  icon,
  shortcut,
}: MenuItemProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx('group menu-item rounded-sm', className)}
    >
      {icon && <span className="menu-item-icon">{icon}</span>}
      {children}
      {shortcut && (
        <span aria-hidden="true" className="ml-auto pl-2">
          {/* Same key cap as the shortcuts modal and the ButtonIcon tooltips,
              including their convention of capitalising single letters. */}
          <Kbd className={clsx(shortcut.length === 1 && 'uppercase')}>{shortcut}</Kbd>
        </span>
      )}
    </button>
  );
}

export default MenuItem;
